import React from 'react'

export default function DetailedView(props) {
    if (!props.board || Object.keys(props.board).length == 0) {
        return <></>
    }
    return (
       <table id="print-table" >
           <tr>
               <td colSpan="3" style={{fontSize: "20px", fontWeight: "bolder", textAlign: "center", textTransform: "uppercase"}}>{props.title}</td>
               <td></td>
               <td></td>
           </tr>
           <tr>
               <td width="10%" style={{fontSize: "18px", fontWeight: "bolder", fontFamily: "Oswald"}}>ACT 1</td>
               <td width="45%"></td>
               <td width="45%"></td>
           </tr>
            {props.board[1].columns.map((beat) => {
                let ranges = ''
                if (beat.percent == null) {
                    ranges = `${props.amount * beat.begPercent/100} - ${props.amount * beat.endPercent/100} ${props.metric}`
                }
                else {
                    ranges = `${props.amount * beat.percent/100} ${props.metric}`
                }
                return (
                    <>
                        <tr>
                            <td></td>
                            <td style={{fontSize: "14px", fontWeight: "bold"}}>{ beat.title }</td>
                            <td></td>
                        </tr>
                        <tr>
                            <td></td>
                            <td style={{fontSize: "14px", fontWeight: "bold", fontStyle: "italic"}}>{ ranges }</td>
                            <td></td>
                        </tr>
                        <tr>
                            <td></td>
                            <td  style={{fontSize: "14px", fontStyle: "italic"}}>{ beat.desc }</td>
                            <td></td>
                        </tr>
                        {beat.cards.map((card) => {
                            return (
                                <tr>
                                    <td></td>
                                    <td></td>
                                    <td style={{fontSize: "14px"}}>{ card.title }</td>
                                </tr>
                            )
                        })}
                    </>
                )
            })}

            <tr>
                <td></td>
                <td></td>
                <td></td>
            </tr>

            <tr>
               <td style={{fontSize: "18px", fontWeight: "bolder"}}>ACT 2</td>
               <td></td>
               <td></td>
           </tr>
            {props.board[2].columns.map((beat) => {
                let ranges = ''
                if (beat.percent == null) {
                    ranges = `${props.amount * beat.begPercent/100} - ${props.amount * beat.endPercent/100} ${props.metric}`
                }
                else {
                    ranges = `${props.amount * beat.percent/100} ${props.metric}`
                }
                return (
                    <>
                        <tr>
                            <td></td>
                            <td style={{fontSize: "14px", fontWeight: "bold"}}>{ beat.title }</td>
                            <td></td>
                        </tr>
                        <tr>
                            <td></td>
                            <td style={{fontSize: "14px", fontWeight: "bold", fontStyle: "italic"}}>{ ranges }</td>
                            <td></td>
                        </tr>
                        <tr>
                            <td></td>
                            <td  style={{fontSize: "14px", fontStyle: "italic"}}>{ beat.desc }</td>
                            <td></td>
                        </tr>
                        {beat.cards.map((card) => {
                            return (
                                <tr>
                                    <td></td>
                                    <td></td>
                                    <td style={{fontSize: "14px"}}>{ card.title }</td>
                                </tr>
                            )
                        })}
                    </>
                )
            })}

            <tr>
                <td></td>
                <td></td>
                <td></td>
            </tr>

            <tr>
               <td style={{fontSize: "18px", fontWeight: "bolder"}}>ACT 3</td>
               <td></td>
               <td></td>
           </tr>
            {props.board[3].columns.map((beat) => {
                let ranges = ''
                if (beat.percent == null) {
                    ranges = `${props.amount * beat.begPercent/100} - ${props.amount * beat.endPercent/100} ${props.metric}`
                }
                else {
                    ranges = `${props.amount * beat.percent/100} ${props.metric}`
                }
                return (
                    <>
                        <tr>
                            <td></td>
                            <td style={{fontSize: "14px", fontWeight: "bold"}}>{ beat.title }</td>
                            <td></td>
                        </tr>
                        <tr>
                            <td></td>
                            <td style={{fontSize: "14px", fontWeight: "bold", fontStyle: "italic"}}>{ ranges }</td>
                            <td></td>
                        </tr>
                        <tr>
                            <td></td>
                            <td style={{fontSize: "14px", fontStyle: "italic"}}>{ beat.desc }</td>
                            <td></td>
                        </tr>
                        {beat.cards.map((card) => {
                            return (
                                <tr>
                                    <td></td>
                                    <td></td>
                                    <td style={{fontSize: "14px"}}>{ card.title }</td>
                                </tr>
                            )
                        })}
                    </>
                )
            })}
       </table>
    )
}
